let deleteMixin = {
  data () {
    return {
      deleteUrl: this.getDomain() + 'article/delete',
    }
  },
  methods: {
    getDelete(id) {
      this.__confirm('确认删除？', this.__axios, [this.deleteUrl, {_id: id}, this.handleDelete])
    },
    handleDelete() {
      this.$message.success('删除成功');
      this.getList()
    }
  }
};

export default deleteMixin
